const normalize = (value) => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

// Resolve against the same catalogue used by CityField; never trust reverse-geocoding text alone.
export async function resolveSupportedCity(name) {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || ""}/api/utils/search-cities?${new URLSearchParams({ q: name })}`);
  if (!response.ok) throw new Error("Impossibile verificare la città");
  const data = await response.json();
  const matches = (Array.isArray(data?.results) ? data.results : []).filter(city => normalize(city.name) === normalize(name));
  if (matches.length !== 1) throw Object.assign(new Error("Seleziona una città dall’elenco"), { code: "UNSUPPORTED_CITY" });
  const city = matches[0];
  return { name: city.name, provincia: String(city.provincia || "").toUpperCase(), cap: city.cap || "" };
}
